import React from 'react';
import {
  FaLinkedinIn,
  FaInstagram,
  FaWhatsapp,
  FaFacebookF,
  FaXTwitter,
} from 'react-icons/fa6';
import { MdEmail, MdLocationOn } from 'react-icons/md';
import { BsTelephoneFill } from 'react-icons/bs';
import Logo from '@assets/images/header/Footer2.png';
import styles from './Footer.module.scss';

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.column}>
          <img src={Logo} alt="Logo" className={styles.logo} />
          <p>
            DGMTech Solutions is a Surat-based IT company <br />specializing in custom web development,<br /> mobile app development, and UI/UX design.
          </p>
          <div className={styles.socialIcons}>
            <a href="#" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
            <a href="#" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://wa.me/919825805271" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
            <a href="#" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="#" target="_blank" rel="noopener noreferrer"><FaXTwitter /></a>
          </div>
        </div>

        <div className={styles.column}>
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/about-us">About</a></li>
            <li><a href="/career">Career</a></li>
            <li><a href="/portfolio">Portfolio</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        <div className={styles.column}>
          <h4>Our Services</h4>
          <ul>
            <li><a href="/web-development">Web Development</a></li>
            <li><a href="/app-development">App Development</a></li>
          </ul>
        </div>

        <div className={styles.column}>
          <h4>Contact Us</h4>
          <ul>
            
            <li>
              <a href="https://mail.google.com/mail/?view=cm&fs=1&to=dgmtechsolution@gmail.com"
                   target="_blank"
                   rel="noopener noreferrer">
                    <MdEmail />  Write to us :<br />dgmtechsolution@gmail.com
              </a>
            </li>
            <li>
              <a href="tel:+919825805271">
              <BsTelephoneFill /> +91 982580-5271
              </a> 
            </li>
            <li>
              <a href="https://www.google.com/maps/place/Rise+On+Plaza,+Sarthana+Jakatnaka,+Surat,+Gujarat+395008/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'none', color: 'inherit' }}>
              <MdLocationOn />
              228 Rise on plaza,<br /> Sarthana Jakatnaka,<br /> Surat, Gujarat-395008
            </a></li>

          </ul>
        </div>
      </div>

      <div className={styles.bottom}>
        <p>© {new Date().getFullYear()} DGM, All Right Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
